module.exports = __webpack_public_path__ + "img/ok_clipboard.66f6ea5a.svg";